(function () {
  document.querySelectorAll('[data-ss-pdp-details-collapsible]').forEach(function (shell) {
    var body = shell.querySelector('[data-ss-pdp-details-body]');
    var toggle = shell.querySelector('[data-ss-pdp-details-toggle]');
    var fade = shell.querySelector('[data-ss-pdp-details-fade]');
    var label = shell.querySelector('[data-ss-pdp-details-toggle-label]');
    if (!body || !toggle) return;

    var moreText = toggle.dataset.readMore || (label && label.textContent) || 'Read full description';
    var lessText = toggle.dataset.readLess || 'Show less';

    function setExpanded(expanded) {
      shell.classList.toggle('is-expanded', expanded);
      body.classList.toggle('is-collapsed', !expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) label.textContent = expanded ? lessText : moreText;
      if (fade) fade.hidden = expanded;
    }

    toggle.addEventListener('click', function () {
      setExpanded(!shell.classList.contains('is-expanded'));
    });

    setExpanded(false);
  });
})();
